import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProNavigationService } from './pro-navigation.service';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class JobMetasResolver  {

    constructor(
        private proNavigationService: ProNavigationService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot
    ): Observable<any> {
        return this.proNavigationService.job.pipe(
            take(1),
            tap((job) => {
                const metas = this.proNavigationService.initMetas(this.proNavigationService.getMetasJob(job), route, true);
                route.data = {...route.data, metasOverride : { ...route.data.metas , ...metas }};
            })
        );
    }
}
